import logger from '@/modules/logger/constants/logger';
import { Button, ErrorPage } from '@thisisdmg/tirecloud-patterns/v2';
import { useTranslation } from 'react-i18next';

export default function ErrorMaintenance({
  message,
}: {
  message?: { title?: string; description?: string };
}) {
  const { t } = useTranslation();

  return (
    <ErrorPage
      code={[5, 0, 3]}
      title={
        <span
          dangerouslySetInnerHTML={{
            __html: message?.title ?? t('error_maintenance.title'),
          }}
        />
      }
      description={
        <span
          dangerouslySetInnerHTML={{
            __html: message?.description ?? t('error_maintenance.description'),
          }}
        />
      }
      actionButtons={
        <div className="tc:inline-flex tc:gap-x-2">
          <Button.Solid
            color="brand"
            onClick={async () => {
              try {
                // clear all caches
                if (window.caches !== undefined) {
                  const keys = await window.caches.keys();
                  await Promise.all(
                    keys.map((key) => window.caches.delete(key))
                  );
                }
              } catch (e) {
                logger.error('core.pwa', e);
              }
              window.location.reload();
            }}
          >
            {t('common.reload')}
          </Button.Solid>
        </div>
      }
    />
  );
}
